import {ScrollTrigger} from "gsap/ScrollTrigger";
import Video from "../useVideo";
import Snap from "../useSnap";
import utils from '../../utils';

const { triggerEventOnce } = utils;

function Anudip({element}) {
    this.element = element;

    this.init = () => {
        if( $(window).width() <= 1024 ) {
            let video = this.element.querySelector( ".video-animation" );

            ScrollTrigger.create( {
                scroller: "[data-scroll-container]",
                trigger: this.element,
                scrub: 1,
                start: "top bottom",
                end: "bottom bottom",
                onEnter: (self) => {
                    video.play();
                    triggerEventOnce('2022-accenture-animation1');
                }
            } );
        } else {
            this.video = new Video({
                // path: "https://create-apac.imgix.net/accenture-2022/images/sequences/1-Anudip/Anudip_",
                path: "../images/sequences/1-Anudip/Anudip_",
                canvas: this.element.querySelector("canvas"),
                counter: 181,
                onUpdateCallback: () => {
                    triggerEventOnce('2022-accenture-animation1');
                }
            });

            this.snap = new Snap({
                element: this.element,
                transitionTo: '.section--1',
                forceEnd: true,
                mobileOffset: -60,
                goToPoint: (animationPoint, duration, counter, nextPoint) => {
                    this.video.goToPoint(animationPoint, duration, counter);
                }
            });

            this.snap.init();
        }
    };
}

export default function () {
    document.querySelectorAll("[data-anudip]").forEach((elem) => {
        let anudip = new Anudip({element: elem});

        anudip.init();
    });
}